<template>

  <div v-if="contracts.length !== 0" class="flex flex-col gap-4">
    <template v-for="contract in contracts" :key="contract.value">
      <div v-if="contract.status !== 'coming'">
        <input
          type="radio"
          name="rentalObjectCode"
          class="peer hidden"
          :key="contract.value"
          :value="contract.value"
          :id="contract.value"
          :checked="internalValue === contract.value"
          @change="onChange(contract.value, null, contract.floorPlanUrl)"
        />
        <Label :val="contract.value" :id="contract.value" :name="contract.name" :floorPlanUrl="contract.floorPlanUrl" :internalValue="internalValue" :onChange="onChange" />

      </div>
    </template>
  </div>
  <div v-else>Det verkar inte som du har några kontrakt av den aktuella typen.</div>
</template>

<script>
import Label from '@/components/ui/label';
export default {
  name: 'ChooseContractForLaundry',
  components: { Label },
  props: {
    areaCode: {
      type: String,
      required: true,
    },
    rentalObjectCode: {
      type: String,
      required: true,
    },
    dir: {
      required: false
    }
  },
  data() {
    return {
      showLoader: false,
      internalValue: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },
  },
  computed: {
    /**
     * Kontrakt, filtrerar på typ av area man valt.
     */
    contracts() {
      return this.$store.getters.getApartmentContracts;
    },

    /**
     * Används av söken, om den visas
     */
    searchableOptions() {
      let options = {};
      this.contracts.forEach((opt) => {
        options[opt.value] = opt.name;
      });

      return options;
    },
  },
  methods: {
    onChange(value, id, floorPlanUrl) {
      if (this.internalValue === value) {
        this.internalValue = null;
        this.$emit('update:rentalObjectCode', null)
        this.$emit('update:floorPlanUrl', null)
        this.$emit('change', null);
      } else {
        this.internalValue = value;
        this.$emit('update:rentalObjectCode', value)
        this.$emit('update:floorPlanUrl', floorPlanUrl)
        this.$emit('change', value);
      }
    },
  },
  created() {
    this.internalValue = this.rentalObjectCode;
    if (this.rentalObjectCode) {
      this.$emit('update:rentalObjectCode', this.rentalObjectCode);
      this.$emit('change', this.rentalObjectCode);
    }
  },
};
</script>
